@if(pageService.viewDroplistItems.length){
<div class='delivery-engagements-views-part'>
	@if(pageService.selectedViewItem(); as selectedViewItem){
	<droplist class="views-droplist" [items]='pageService.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='pageService.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' [groupSortValues]='{ "People":1, "Engagements":2 }' style='display:inline-block'>
	</droplist>
	@switch (selectedViewItem.uniqueId) {
	@case (pageService.viewId.Teams) {
	<acc-teams-view-part></acc-teams-view-part>
	}
	@case (pageService.viewId.Ventures) {
	<acc-ventures-view-part></acc-ventures-view-part>
	}
	@case (pageService.viewId.Entrepreneurs) {
	<acc-entrepreneurs-view-part></acc-entrepreneurs-view-part>
	}
	@case (pageService.viewId.Mentors) {
	<acc-mentors-view-part></acc-mentors-view-part>
	}
	@case (pageService.viewId.Specialists) {
	<acc-specialists-view-part></acc-specialists-view-part>
	}
	@case (pageService.viewId.OpenEngagements) {
	<acc-open-engagements-view-part></acc-open-engagements-view-part>
	}
	@case (pageService.viewId.CompletedEngagements) {
	<acc-completed-engagements-view-part></acc-completed-engagements-view-part>
	}
	@case (pageService.viewId.ScheduledFollowUps) {
	<acc-scheduled-follow-ups-view-part></acc-scheduled-follow-ups-view-part>
	}
	@case (pageService.viewId.GoalsAndProgress) {
	<acc-goals-and-progress-view-part></acc-goals-and-progress-view-part>
	}
	}
	}

</div>
}